/**
 * 富文本渲染兜底工具
 *
 * 统一约定：Markdown / 纯文本一律由后端转成 HTML（contentHtml），前端只负责渲染。
 * 这里只做兼容处理：接口还没返回 contentHtml 时，把原文转义后渲染，
 * 避免 v-html 直接渲染出裸标签，也避免内容里带 < > 时被当成 HTML 吞掉。
 */

/** HTML 文本转义 */
export function escapeHtml(text) {
  if (text === null || text === undefined) return ''
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

/** 纯文本 → HTML：转义 + 换行折行（用于兜底渲染） */
export function textToHtml(text) {
  const escaped = escapeHtml(text)
  if (!escaped) return ''
  return escaped.replace(/\n/g, '<br/>')
}

/**
 * 取出可直接 v-html 的内容
 * @param {Object} item 后端返回对象
 * @param {String} htmlField HTML 字段名，默认 contentHtml
 * @param {String} rawField 原文兜底字段名，默认 content
 */
export function resolveContentHtml(item, htmlField = 'contentHtml', rawField = 'content') {
  if (!item) return ''
  const html = item[htmlField]
  if (html !== null && html !== undefined && String(html).trim() !== '') {
    return html
  }
  return textToHtml(item[rawField])
}
